import axios, { AxiosError } from "axios";
import { toast } from "react-toastify";

type HubspotStatusType = "error" | ""; // To be filled by success status

type HubspotErrorType = { message: string };

type HubspotResponseType = {
  redirectUri: string | undefined;
  status: HubspotStatusType;
  errors: HubspotErrorType[];
};

const useHubSpotForm = (
  portalId: string,
  guid: string,
  callback?: () => void
) => {
  const submitForm = async (payload: unknown) => {
    const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${guid}`;
    try {
      const response = await axios<HubspotResponseType>({
        method: "POST",
        url,
        data: payload,
        headers: {
          "Content-Type": "application/json",
        },
      });
      const resData = response?.data;
      if (resData?.redirectUri) {
        window?.open(resData?.redirectUri, "_newtab");
      } else {
        toast.success("Thank you for submitting the details.");
      }
      callback?.();
    } catch (error) {
      // eslint-disable-next-line no-console
      const { errors: hError } =
        (error as AxiosError<HubspotResponseType>)?.response?.data ?? {};
      const [firstError] = hError ?? [];
      const firstErrorMessage = firstError?.message;
      toast.error(
        firstErrorMessage ?? "Error occurred while submitting the form"
      );
    }
  };
  return { submitForm };
};

export default useHubSpotForm;
